import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import useAppPromotionTheme from "../hooks/useAppPromotionTheme"
import ModuleJDBWinnersLeague from "./promotion_modules/ModuleJDBWinnersLeague"

export default function JDBWinnersLeague({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode)
  const data = promotionsData.find(
    (promo) => promo.title === "JDB's Winners League"
  )
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [activeModal, setActiveModal] = useState("")
  const navigate = useNavigate()

  const modalComponents = {
    "JDB's Winners League": ModuleJDBWinnersLeague,
  }

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  const handleJDBWinnerLeague = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("JDB's Winners League")
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>JDB's Winners League</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>
              / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1>JDB's Winners League: Total Winnings Showdown</h1>
                  <h2>Every Win Counts - Stack to the Top</h2>
                  <div className="promotion-tnc-period">
                    <strong> Event Period: </strong>
                    <span> July 2 - July 30, 2026 </span>
                  </div>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  {isLoggedIn && !isAppPromo && (
                    <div className="promotion-tnc-btn-wrapper">
                      <button
                        className="promotion-cta-btn"
                        onClick={handleJDBWinnerLeague}
                      >
                        Leaderboard
                      </button>
                    </div>
                  )}
                  <strong>Terms and Conditions</strong>
                  <ol>
                    <li>
                      All FGH players are eligible to participate in the promo.
                    </li>
                    <li>
                      Play any JDB slot games - total winnings per round will be
                      accumulated.
                    </li>
                    <li>
                      The Top 25 players with the highest accumulated winnings
                      during each weekly cut-off will be declared winners.
                    </li>
                    <li>
                      A minimum turnover of 1,000 is required to qualify for the
                      Top 25 winners.
                    </li>
                    <li>
                      Weekly cut-off runs from Thursday, 12:00 NN to the
                      following Thursday, 11:59 AM.
                    </li>
                    <li>Prizes will be awarded every Thursday at 3:00 PM</li>
                  </ol>

                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <tr>
                          <th colSpan={4}>Weekly Rewards</th>
                        </tr>
                        <tr>
                          <th>Rank Group</th>
                          <th>Free Spins</th>
                          <th>Bet Value</th>
                          <th>Rollover</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>Rank 1</td>
                          <td>500</td>
                          <td>₱25.00</td>
                          <td rowSpan={5} style={{ verticalAlign: "middle" }}>
                            No Rollover Requirement
                          </td>
                        </tr>
                        <tr>
                          <td>Rank 2</td>
                          <td>250</td>
                          <td>₱20.00</td>
                        </tr>
                        <tr>
                          <td>Rank 3</td>
                          <td>150</td>
                          <td>₱15.00</td>
                        </tr>
                        <tr>
                          <td>Ranks 4 - 15</td>
                          <td>70</td>
                          <td>₱10.00</td>
                        </tr>
                        <tr>
                          <td>Ranks 16 - 25</td>
                          <td>50</td>
                          <td>₱5.00</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <ol start={7}>
                    <li>
                      FGH reserves the right to amend, extend, or terminate this
                      promotion at any time without prior notice.
                    </li>
                  </ol>

                  {!isAppPromo && (
                    <div className="promotion-tnc-cta">
                      <a
                        className="promotion-cta-btn"
                        href="/slots/?provider=JDB"
                      >
                        PLAY NOW
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal("")} />}
    </>
  )
}
